import React, { useState } from 'react';
import ActionSheet from 'devextreme-react/action-sheet';
import { getNonBFIExperienceActions, executeNonBFIExperienceAction } from '../ExperienceFunctions';
import { InformModal } from '../../../common/SharedComponents';
import { ConfirmModal } from '@apply/ui';
import { NonBFIExperienceActionType } from '../ExperienceConstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const NonBFIExperienceActionsButton = ({ experience }) => {
    const [actionData, set_actionData] = useState({
        visible: false,
        target: null,
        items: [],
    });
    const [informModalOpen, set_informModalOpen] = useState(false);
    const [openConfirmModal, set_openConfirmModal] = useState(false);
    const [actionItem, set_actionItem] = useState(null);

    const onActionClicked = (event, exp) => {
        event.preventDefault();
        event.stopPropagation();

        const actions = getNonBFIExperienceActions(exp);

        if (actions.length === 0) {
            set_informModalOpen(true);
            return;
        }

        var data = {
            items: actions,
            target: `#${event.target.id}`,
            visible: true,
        };
        set_actionData(data);
    };

    const onActionItemClick = (e) => {
        set_actionData({ ...actionData, visible: false });
        if (e.itemData.id === NonBFIExperienceActionType.DeleteNonBfi) {
            set_actionItem(e.itemData);
            set_openConfirmModal(true);
            return;
        }
        executeNonBFIExperienceAction(e.itemData);
    };

    const onActionSheetVisibleChange = (isVisible) => {
        if (isVisible !== actionData?.visible) {
            set_actionData({ ...actionData, visible: isVisible });
        }
    };

    const onConfirmModalCallback = () => {
        executeNonBFIExperienceAction(actionItem);
        set_openConfirmModal(false);
        set_actionItem(null);
    };

    const onConfirmModalCancel = () => {
        set_openConfirmModal(false);
        set_actionItem(null);
    };

    if (!experience) {
        return null;
    }

    return (
        <>
            <button
                id={`action_${experience.id}_${experience.principalId}`}
                className='gridButton'
                title='Click to see options'
                onClick={(event) => onActionClicked(event, experience)}
            >
                ...
            </button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onActionSheetVisibleChange}
                showTitle={false}
            />
            <InformModal
                isOpen={informModalOpen}
                text={'No actions available'}
                confirmCallback={() => set_informModalOpen(false)}
            />
            <ConfirmModal
                isOpen={openConfirmModal}
                text='Are you sure you want to delete this experience. It can NOT be undone!'
                confirmCallback={onConfirmModalCallback}
                cancelCallback={() => onConfirmModalCancel()}
            >
                <div>
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        style={{ color: 'darkred' }}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <b>Warning</b>
                    <br />
                    <br />
                    <div>
                        This will remove this experience from the experience tables. It will no longer be visible to any Admin
                        user or the originating Principal.
                        <br />
                        <br />
                        Are you sure you want to perform this action?
                    </div>
                </div>
            </ConfirmModal>
        </>
    );
};
